<script lang="ts">
    import { DRAWER_POSITION } from "@/constants/drawer";
    import { registerElementInIndex } from "@lib/ElementsIndex/registerElementAction";
    import CN from "classnames";

    export let title: string;
    export let ariaLabel: string;
    export let direction: DRAWER_POSITION;
    export let elementName: string;
</script>

<button
    on:click
    on:mouseenter
    class={CN("gw-drawer-open-btn", `gw-drawer-open-btn--${direction}`)}
    aria-label={ariaLabel}
>
    <span
        use:registerElementInIndex={elementName}
        class="gw-drawer-open-btn__icon"
    >
        <slot name="icon" />
    </span>
    <span class="gw-drawer-open-btn__text"> {title}</span>
</button>

<style lang="postcss">
    .gw-drawer-open-btn {
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: 40px;
        padding: 0 1.5em 0 0.5em;
        column-gap: 5px;
        border: none;
        background-color: var(--gw-drawer-btn-bg-color);
        box-shadow: var(--gw-drawer-btn-box-shadow);
        cursor: pointer;

        @media all and (max-width: 480px) {
            padding: 0 0 0 0.5em;
        }

        &--LC {
            border-radius: 0 0 var(--gw-drawer-btn-border-radius)
                var(--gw-drawer-btn-border-radius);
        }

        &--RC {
            border-radius: var(--gw-drawer-btn-border-radius)
                var(--gw-drawer-btn-border-radius) 0 0;
        }

        &__text {
            color: var(--gw-drawer-btn-text-color);
            font-size: 0.9em;
            font-weight: bold;
            text-align: center;
            text-transform: uppercase;

            @media all and (max-width: 480px) {
                display: none;
            }
        }
        &__icon {
            display: flex;
            position: relative;
            align-items: center;
            justify-content: center;
            width: 32px;
            height: 32px;
            margin-right: 7px;
            transform: rotate(90deg);
            border-radius: 50%;
            background-color: var(--gw-drawer-btn-icon-bg-color);
        }
    }
</style>
